<script>
import moment from 'moment';
moment.locale('pt-BR');

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import SaleService from '@/services/sale'
import { productColor } from '@/utils/product';

export default {
  page: {
    title: "Painel de Pedidos",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  data() {
    return {
      newSales: [],
      inProgressSales: [],
      readySales: [],
      title: "Painel de Pedidos",
      user: {},
      showModal: false,
      saleSelected: {
        items: [],
        customer: {},
        shipping: {},
      },
      itemsFields: [
        { key: 'image', label: 'Produto' },
        { key: 'product.code', label: 'Cód.' },
        { key: 'description', label: 'Descrição' },
        { key: 'quantity', label: 'Qtde.' },
        { key: 'subtotal', label: 'Subtotal', formatter: (value, index, item) => {
          return ((item.quantity * item.price) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
      ],
    };
  },
  sockets: {
    newSale() {
      this.$toast.open('Novo pedido recebido');

      this.loadSales(false);
    },
    updateSale() {
      this.loadSales(false);
    },
    broadcast() {
      // eslint-disable-next-line no-console
      console.log('aguardando novos pedidos', new Date())
    }
  },
  mounted() {
    this.loadSales();

    this.connectSocket();
  },
  methods: {
    productColor,
    formatSales(sales) {
      return sales.map(item => {
        return {
          ...item,
          phone_number_link: item.customer.phone_number ? `https://api.whatsapp.com/send?phone=55${item.customer.phone_number.replace(/\D/g, '')}` : '',
          has_delivery_integration: (item.shipping && item.shipping.integration && item.shipping.integration.status) ? true : false,
        }
      });
    },
    loadSales(showLoading = true) {
      let loader;
      if (showLoading) {
        loader = this.$loading.show();
      }

      SaleService.getBoardSales()
        .then(res => {
          if (loader) {
            loader.hide();
          }

          this.newSales = this.formatSales(res.data.newSales);
          this.inProgressSales = this.formatSales(res.data.inProgressSales);
          this.readySales = this.formatSales(res.data.readySales);

          if (!showLoading) {
            this.$forceUpdate();
          }
        })
      .catch(() => {
        if (loader) {
          loader.hide();
        }
      })
    },
    formatDate(value) {
      if (value) {
        return moment(value).format('DD/MM/YYYY HH:mm');
      }

      return '-';
    },
    changeStatus(saleId, status) {
      let loader = this.$loading.show();
      SaleService.changeStatus(saleId, status).then(() => {
        this.loadSales(false);

        loader.hide();

        this.$toast.open('Status do pedido alterado');
      }).catch(() => {
        loader.hide();
        this.$toast.error('Ocorreu um erro ao alterar o status do pedido');
      })
    },
    connectSocket() {
      this.$store.dispatch('USER_DATA').then((res) => {
        this.user = res;

        this.$socket.emit('subscribe', this.user.user_id);
      })
    },
    showItems(sale) {
      this.saleSelected = sale;
      this.showModal = true;
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-lg-4">
        <b-card no-body class="mb-2">
          <b-card-header header-tag="header" class="bg-soft-success">
            <h4 class="card-title text-success mb-0">PEDIDOS NOVOS</h4>
          </b-card-header>
        </b-card>

        <b-card class="mb-2" v-for="sale in newSales" :key="sale._id">
          <div class="row">
            <div class="col float-left">
              <p class="text-muted mb-2">
                PEDIDO {{sale.code}}
                <router-link tag="a" :to="'/sales/detail/' + sale._id">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </router-link>
              </p>
              <p class="text-muted mb-0"><i class="bx bx-time-five font-size-10 mr-1"></i>{{ formatDate(sale.date) }}</p>
              <p v-if="sale.payment.payment_option" class="mb-0 text-muted"><i class="bx bx-money font-size-10 mr-1"></i>{{sale.payment.payment_option.description}} {{sale.payment.installments && sale.payment.installments > 1 ? ` (${sale.payment.installments}x)` : ''}}</p>
              <p v-if="sale.shipping.shipping_option" class="mb-0 text-muted"><i class="bx bxs-truck font-size-10 mr-1"></i>{{sale.shipping.shipping_option.description}}</p>
            </div>

            <div class="col text-right">
              <span
                class="badge badge-pill badge-soft-primary font-size-12 mt-0 mb-2 ml-0"
                :class=" {
                  'badge-soft-danger': sale.status === 'canceled',
                  'badge-soft-success': sale.status === 'new',
                  'badge-soft-secondary': sale.status === 'completed',
                }"
              >{{sale.statusDescription}}</span>

              <h5 class="font-size-15 mb-1">{{(sale.total_value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</h5>
              <p class="text-muted mb-4">
                {{sale.items.length}} {{sale.items.length > 1 ? 'itens' : 'item'}}
                <a href="javascript:void(0);" class="action-icon text-success ml-1" @click="showItems(sale)">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </a>
              </p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col float-left">
              <h5 class="font-size-13 mb-1">{{sale.customer.name}}</h5>
              <p class="mb-0" v-if="sale.customer.phone_number">
                {{sale.customer.phone_number}}
                <a :href="sale.phone_number_link" target="_blank" class="action-icon text-success ml-1" @click="showItems(sale)">
                  <i class="bx bxl-whatsapp font-size-16"></i>
                </a>
              </p>
            </div>

            <div class="col float-right text-right">
              <b-button variant="success" @click="changeStatus(sale._id, 'confirmed')">Confirmar</b-button>
            </div>
          </div>

          <div class="row pt-3 mt-3 border-top justify-content-center" v-if="sale.seller">
            <div class="col justify-content-center">
              <p class="mb-0">Vendedor: <span class="font-weight-bold">{{sale.seller.name}}</span></p>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-lg-4">
        <b-card no-body class="mb-2">
          <b-card-header header-tag="header" class="bg-soft-primary">
            <h4 class="card-title text-primary mb-0">PEDIDOS EM ANDAMENTO</h4>
          </b-card-header>
        </b-card>

        <b-card class="mb-2" v-for="sale in inProgressSales" :key="sale._id">
          <div class="row">
            <div class="col float-left">
              <p class="text-muted mb-2">
                PEDIDO {{sale.code}}
                <router-link tag="a" :to="'/sales/detail/' + sale._id">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </router-link>
              </p>
              <p class="text-muted mb-0"><i class="bx bx-time-five font-size-10 mr-1"></i>{{ formatDate(sale.date) }}</p>
              <p v-if="sale.payment.payment_option" class="mb-0 text-muted"><i class="bx bx-money font-size-10 mr-1"></i>{{sale.payment.payment_option.description}} {{sale.payment.installments && sale.payment.installments > 1 ? ` (${sale.payment.installments}x)` : ''}}</p>
              <p v-if="sale.shipping.shipping_option" class="mb-0 text-muted"><i class="bx bxs-truck font-size-10 mr-1"></i>{{sale.shipping.shipping_option.description}}</p>
            </div>

            <div class="col text-right">
              <span
                class="badge badge-pill badge-soft-primary font-size-12 mt-0 mb-2 ml-0"
                :class=" {
                  'badge-soft-danger': sale.status === 'canceled',
                  'badge-soft-success': sale.status === 'new',
                  'badge-soft-secondary': sale.status === 'completed',
                }"
              >{{sale.statusDescription}}</span>

              <h5 class="font-size-15 mb-1">{{(sale.total_value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</h5>
              <p class="text-muted mb-4">
                {{sale.items.length}} {{sale.items.length > 1 ? 'itens' : 'item'}}
                <a href="javascript:void(0);" class="action-icon text-success ml-1" @click="showItems(sale)">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </a>
              </p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col float-left">
              <h5 class="font-size-13 mb-1">{{sale.customer.name}}</h5>
              <p class="mb-0" v-if="sale.customer.phone_number">
                {{sale.customer.phone_number}}
                <a :href="sale.phone_number_link" target="_blank" class="action-icon text-success ml-1" @click="showModal = true">
                  <i class="bx bxl-whatsapp font-size-16"></i>
                </a>
              </p>
            </div>

            <div class="col float-right text-right">
              <b-button size="sm" variant="primary" v-if="sale.status === 'separation' && sale.shipping.method === 'delivery' && !sale.has_delivery_integration" :disabled="sale.has_delivery_integration" @click="changeStatus(sale._id, 'sent')">Mudar p/ Enviado</b-button>
              <b-button variant="primary" v-if="sale.status === 'separation' && sale.shipping.method === 'withdraw'" @click="changeStatus(sale._id, 'ready')">Mudar p/ Pronto</b-button>

              <b-dropdown variant="primary" v-if="sale.status !== 'separation'">
                <template v-slot:button-content>
                  Alterar Status
                  <i class="mdi mdi-chevron-down"></i>
                </template>
                <b-dropdown-item @click="changeStatus(sale._id, 'separation')">Em Separação</b-dropdown-item>
                <b-dropdown-item v-if="sale.shipping.method === 'delivery'" @click="changeStatus(sale._id, 'sent')">Enviado</b-dropdown-item>
                <b-dropdown-item v-if="sale.shipping.method === 'withdraw'" @click="changeStatus(sale._id, 'ready')">Pronto p/ Retirar</b-dropdown-item>
              </b-dropdown>
              
            </div>
          </div>

          <div class="row pt-3 mt-3 border-top justify-content-center" v-if="sale.seller">
            <div class="col justify-content-center">
              <p class="mb-0">Vendedor: <span class="font-weight-bold">{{sale.seller.name}}</span></p>
            </div>
          </div>

          <div class="row pt-3 mt-3 border-top justify-content-center" v-if="sale.shipping.courier_name">
            <div class="col justify-content-center">
              <p class="mb-0">Entregador: <span class="font-weight-bold">{{sale.shipping.courier_name}}</span></p>
            </div>
          </div>
        </b-card>
      </div>

      <div class="col-lg-4">
        <b-card no-body class="mb-2">
          <b-card-header header-tag="header" class="bg-soft-secondary">
            <h4 class="card-title text-secondary mb-0">PRONTOS</h4>
          </b-card-header>
        </b-card>

        <b-card class="mb-2" v-for="sale in readySales" :key="sale._id">
          <div class="row">
            <div class="col float-left">
              <p class="text-muted mb-2">
                PEDIDO {{sale.code}}
                <router-link tag="a" :to="'/sales/detail/' + sale._id">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </router-link>
              </p>
              <p class="text-muted mb-0"><i class="bx bx-time-five font-size-10 mr-1"></i>{{ formatDate(sale.date) }}</p>
              <p v-if="sale.payment.payment_option" class="mb-0 text-muted"><i class="bx bx-money font-size-10 mr-1"></i>{{sale.payment.payment_option.description}} {{sale.payment.installments && sale.payment.installments > 1 ? ` (${sale.payment.installments}x)` : ''}}</p>
              <p v-if="sale.shipping.shipping_option" class="mb-0 text-muted"><i class="bx bxs-truck font-size-10 mr-1"></i>{{sale.shipping.shipping_option.description}}</p>
            </div>

            <div class="col text-right">
              <span
                class="badge badge-pill badge-soft-primary font-size-12 mt-0 mb-2 ml-0"
                :class=" {
                  'badge-soft-danger': sale.status === 'canceled',
                  'badge-soft-success': sale.status === 'new',
                  'badge-soft-secondary': sale.status === 'completed',
                }"
              >{{sale.statusDescription}}</span>

              <h5 class="font-size-15 mb-1">{{(sale.total_value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</h5>
              <p class="text-muted mb-4">
                {{sale.items.length}} {{sale.items.length > 1 ? 'itens' : 'item'}}
                <a href="javascript:void(0);" class="action-icon text-success ml-1" @click="showItems(sale)">
                  <i class="bx bx-link-external text-primary font-size-14"></i>
                </a>
              </p>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col float-left">
              <h5 class="font-size-13 mb-1">{{sale.customer.name}}</h5>
              <p class="mb-0" v-if="sale.customer.phone_number">
                {{sale.customer.phone_number}}
                <a :href="sale.phone_number_link" target="_blank" class="action-icon text-success ml-1" @click="showModal = true">
                  <i class="bx bxl-whatsapp font-size-16"></i>
                </a>
              </p>
            </div>

            <div class="col float-right text-right">
              <b-button variant="secondary" @click="changeStatus(sale._id, 'completed')">Finalizar</b-button>
            </div>
          </div>

          <div class="row pt-3 mt-3 border-top justify-content-center" v-if="sale.seller">
            <div class="col justify-content-center">
              <p class="mb-0">Vendedor: <span class="font-weight-bold">{{sale.seller.name}}</span></p>
            </div>
          </div>
        </b-card>
      </div>
    </div>

    <b-modal v-model="showModal" :title="'Itens do Pedido ' + saleSelected.code" scrollable size="lg">
      <div class="table-responsive">
        <table class="table table-centered">
          <thead>
            <tr>
              <th scope="col">Produto</th>
              <th scope="col">Cód.</th>
              <th scope="col">Descrição</th>
              <th scope="col" class="text-right">Qtde.</th>
              <th scope="col" class="text-right">Preço</th>
              <th scope="col" class="text-right">Subtotal</th>
            </tr>
          </thead>
          <tbody v-if="saleSelected.items">
            <tr v-for="item of saleSelected.items" :key="item._id">
              <td>
                <div>
                  <img :src="item.product.images[0].url" alt class="avatar-sm" />
                </div>
              </td>
              <td>{{item.product.code || item.product.sku}}</td>
              <td>
                <div>
                  <h5 class="font-size-13 mb-1">{{item.product.description}}</h5>
                  <p class="text-muted font-size-11 mb-0" v-if="productColor(item.product)">Cor: {{productColor(item.product)}}</p>
                  <p class="text-muted font-size-11 mb-0" v-for="(complement, index) in item.complements" :key="index">
                    {{complement.quantity}}x {{complement.description}}
                  </p>
                  <p class="text-muted font-size-11 mb-0" v-if="item.note">Obs.: {{item.note}}</p>
                </div>
              </td>
              <td class="text-right">{{item.quantity}}</td>
              <td class="text-right">{{(item.price || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</td>
              <td class="text-right">{{((item.quantity * item.price) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>
  </Layout>
</template>

<style lang="scss">
  .task-box {
    box-shadow: 1px 1px 15px #e1e1e1;
  }
</style>